// Mau thẻ do người dùng tự đặt nên có cả màu rất nhạt lẫn rất đậm; không thể
// dùng thẳng làm màu chữ. Ba hàm dưới đây kéo màu về ngưỡng đọc được.
//
// Đo theo WCAG 2.1, ngưỡng 4.5:1 cho chữ thường.

const NGUONG = 4.5;

// Ngưỡng "thoải mái": trên mức này thì chữ tối trên nền màu đọc dễ, không phải
// cố mắt. Màu nằm dưới nó mà chữ trắng cũng chưa đọc được là màu TRUNG GIAN
// (đỏ tươi, tím, xanh xám) — cả đen lẫn trắng đều lưng chừng, phải kéo màu đậm
// thêm. Xem `nenChipBat`.
const NGUONG_THOAI_MAI = 6;

const tachHex = hex => [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16));

const doSang = ([r, g, b]) => {
  const tuyenTinh = c => {
    const x = c / 255;
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
  };
  const [rr, gg, bb] = [r, g, b].map(tuyenTinh);
  return 0.2126 * rr + 0.7152 * gg + 0.0722 * bb;
};

const tuongPhan = (a, b) => {
  const [hi, lo] = [doSang(a), doSang(b)].sort((x, y) => y - x);
  return (hi + 0.05) / (lo + 0.05);
};

const raHex = ([r, g, b]) =>
  `#${[r, g, b].map(c => Math.round(c).toString(16).padStart(2, '0')).join('')}`;

const hopLe = hex => typeof hex === 'string' && /^#[0-9a-f]{6}$/i.test(hex);

/**
 * Đen hay trắng, tuỳ cái nào đọc rõ hơn khi đặt LÊN màu này.
 *
 * Màu trung tính (olive, xanh xám) không đạt nổi 4.5:1 với cả đen lẫn trắng —
 * trần là khoảng 3:1. Chấp nhận: ở trạng thái này chính mảng màu mới là thứ
 * mang thông tin, chữ chỉ để đọc lại cho chắc.
 */
export function mauChuTrenNen(hex) {
  if (!hopLe(hex)) return '#111827';
  const nen = tachHex(hex);
  const den = tachHex('#111827');
  const trang = tachHex('#FFFFFF');
  return tuongPhan(den, nen) >= tuongPhan(trang, nen) ? '#111827' : '#FFFFFF';
}

/**
 * Chính màu đó nhưng đã kéo đậm (hoặc nhạt) đủ để làm CHỮ trên nền `nen`.
 * Trộn dần về đen hoặc trắng — giữ được sắc, chỉ đổi độ sáng.
 *
 * DỪNG Ở NẤC ĐẦU TIÊN ĐẠT NGƯỠNG, tức nấc còn giữ nhiều màu gốc nhất. Bản đầu
 * quét hết vòng lặp và ghi đè `tot` ở mọi nấc đạt, nên luôn trả về nấc cuối =
 * gần như đen (đo 10/09/2026: mọi thẻ trong lưới tag đều ra chữ đen 15:1). Đọc
 * thì rõ, nhưng cả lưới mất sạch màu — chỉ còn viền mảnh phân biệt, nhìn như
 * một mảng xám.
 *
 * @param {string} hex màu thẻ
 * @param {string} nen màu nền chữ sẽ nằm lên
 * @param {number} [nguong] tương phản tối thiểu; mặc định 4.5 (WCAG chữ thường)
 */
export function mauChuTren(hex, nen, nguong = NGUONG) {
  if (!hopLe(hex) || !hopLe(nen)) return mauChuTrenNen(nen || '#FFFFFF');

  const mau = tachHex(hex);
  const nenRgb = tachHex(nen);
  if (tuongPhan(mau, nenRgb) >= nguong) return hex;

  // Nền sáng thì kéo màu về đen, nền tối thì kéo về trắng.
  const dich = doSang(nenRgb) > 0.5 ? [0, 0, 0] : [255, 255, 255];

  // Đo tương phản trên màu ĐÃ LÀM TRÒN, vì đó mới là màu thật sự trả về. Đo
  // trên màu chưa làm tròn thì có nấc vừa đủ 5.50 mà làm tròn xong còn 5.49 —
  // sai sót nhỏ, nhưng đúng vào thứ cả file này tồn tại để chặn.
  for (let ti = 0.95; ti > 0; ti -= 0.05) {
    const thu = raHex(mau.map((c, i) => c * ti + dich[i] * (1 - ti)));
    if (tuongPhan(tachHex(thu), nenRgb) >= nguong) return thu;
  }
  return raHex(dich);
}

/**
 * Màu `hex` phủ lên `nen` với độ đục `tiLe` — ra đúng màu mắt nhìn thấy.
 *
 * Cần vì chip TẮT có nền tô nhạt bằng chính màu thẻ: tính màu chữ theo nền
 * khung chat trần thì thiếu một nhịp, chữ tụt xuống dưới ngưỡng.
 */
export function tronMau(hex, tiLe, nen) {
  if (!hopLe(hex) || !hopLe(nen)) return nen || '#FFFFFF';
  const [a, b] = [tachHex(hex), tachHex(nen)];
  return raHex(a.map((c, i) => c * tiLe + b[i] * (1 - tiLe)));
}

/**
 * Nền cho chip ĐANG BẬT: chính màu thẻ, trừ khi màu đó không cõng nổi chữ nào.
 *
 * Màu người dùng đặt hay rơi vào khoảng giữa (đỏ tươi, tím, xanh xám): chữ
 * trắng chưa đủ tương phản mà chữ tối cũng chỉ vừa đủ, nhìn đục. Với những màu
 * đó kéo đậm thêm cho tới khi chữ trắng đọc rõ — ra đúng kiểu thẻ đặc của
 * Pancake (đỏ đậm + chữ trắng) thay vì đỏ tươi + chữ đen.
 *
 * Màu vốn đã sáng rõ (vàng, xanh nõn) giữ nguyên: kéo đậm chỉ làm chúng thành
 * nâu bùn, mà chữ tối trên đó vốn đã đọc tốt.
 */
export function nenChipBat(hex) {
  if (!hopLe(hex)) return '#111827';

  const mau = tachHex(hex);
  const trang = tachHex('#FFFFFF');
  const den = tachHex('#111827');

  if (tuongPhan(trang, mau) >= NGUONG) return hex;
  if (tuongPhan(den, mau) >= NGUONG_THOAI_MAI) return hex;

  // Làm tròn trước khi đo — cùng lý do với `mauChuTren`.
  for (let ti = 0.95; ti > 0; ti -= 0.05) {
    const thu = raHex(mau.map(c => c * ti));
    if (tuongPhan(trang, tachHex(thu)) >= NGUONG) return thu;
  }
  return '#111827';
}

// Xuat rieng cho test do tuong phan; khong dung o cho khac.
export const noiBo = { doSang, tuongPhan, tachHex };
